import 'PackWerkNurikaeSite/pages/home/index/partials/banner_slide/component.scss'
import './images/top_slide_book_banner.webp'
import './images/top_slide_campaign_banner.webp'
import './images/top_slide_consultation_banner.webp'
import './images/top_slide_guide_banner.webp'
import './images/top_slide_nurikae_banner.webp'
import { Controller } from 'stimulus'
import { Splide } from '@splidejs/splide'
import '@splidejs/splide/css'

const BANNER_WIDTH = 524; // バナーの幅
const GAP = 28;           // スライド間の間隔

class BannerSlideController extends Controller {
  connect() {
    // Splideインスタンスを保持
    this.splideInstance = null;
    this.resizeTimer = null;

    // 初期化
    this.initializeSlider();

    // リサイズイベント
    this.boundResize = this.handleResize.bind(this);
    window.addEventListener('resize', this.boundResize);
  }

  disconnect() {
    // クリーンアップ
    if (this.splideInstance) {
      this.splideInstance.destroy();
      this.splideInstance = null;
    }

    if (this.boundResize) {
      window.removeEventListener('resize', this.boundResize);
    }

    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }
  }

  // padding値を動的に計算する関数
  // padding = (コンテナ幅 - バナー幅) / 2
  // 例: containerWidth = 1076px の場合 → padding = (1076 - 524) / 2 = 276px
  calculatePadding() {
    const slider = document.getElementById('home-banner-slider');
    if (!slider) return '0px';

    // 親要素（.banner-slide__wrapper）の幅を取得
    const containerWidth = slider.parentElement.offsetWidth;

    // padding計算（gapはSplideが別途処理するため含めない）
    const padding = Math.max(0, (containerWidth - BANNER_WIDTH) / 2);

    return `${padding}px`;
  }

  // バナースライダー初期化関数
  initializeSlider() {
    const element = document.getElementById('home-banner-slider');
    if (!element) return null;

    const padding = this.calculatePadding();

    const config = {
      type: 'loop',           // ループ
      autoplay: true,         // 自動再生
      interval: 5000,         // 5秒停止
      speed: 400,             // 0.4秒でスライド
      pagination: true,       // インジケーター
      arrows: false,          // 矢印なし
      perPage: 1,             // 1枚ずつ表示
      perMove: 1,             // 1枚ずつ移動
      focus: 'center',        // 中央にフォーカス
      gap: `${GAP}px`,        // スライド間の間隔
      padding: { left: padding, right: padding }, // 動的に計算されたpadding
      pauseOnHover: false,    // ホバー時も自動再生を継続
      pauseOnFocus: false,    // フォーカス時も自動再生を継続
      resetProgress: false,   // 手動操作後も自動再生を継続
    };

    this.splideInstance = new Splide('#home-banner-slider', config);
    this.splideInstance.mount();

    return this.splideInstance;
  }

  // リサイズ時の再初期化
  handleResize() {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
      if (this.splideInstance) {
        this.splideInstance.destroy();
      }
      this.initializeSlider();
    }, 200); // デバウンス処理
  }
}

// StimulusJSに登録
window.Stimulus.register('nurikae-site--pages--home--index--partials--banner-slide', BannerSlideController)
